import { toast } from "react-toastify"
import { AddRecentSearch, usePrevetAPI } from "./usePrevetAPI"
import { useState } from "react"
import axios from "axios"

export function useAddRecentSearch() {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { addRecentSearch } = usePrevetAPI()
  const createRecentSearch = async (search: AddRecentSearch) => {
    try {
      setIsLoading(true)
      await addRecentSearch(search)
    } catch (err: unknown) {
      const message = "Unable to add recents search"
      console.error(message, err)
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { createRecentSearch, isLoading }
}
